module.exports = __webpack_public_path__ + "img/conny-f-stage3.f1f5c5e1.png";